import getApiClient from '@/plugins/api-client'

export default {
    loadSettings() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('settings', {
            params: {
                id: ['event_created_message', 'job_accepted_message', 'job_denied_message', 'job_cancelled_message', 'replace_professional_message', 'survey_sent_message', 'resend_job_invite_message', 'job_invite_resent_message', 'minimum_fee']
            }
        })
            .then(result => {
                self.$store.commit('updateSettings', result.data['hydra:member'])
            })
            .catch(error => {
                console.log(error)
            })
    },

    preventIncompleteUserAccess() {
        const self = this,
            user = self.$store.state.session.user,
            route = self.$route.name

        if (
            user &&
            (!user?.cpf && !user?.company?.cnpj) &&
            user.roles &&
            !['ProfessionalRegister', 'ContractorRegister', 'Logout', 'Login'].includes(route)
        ) {
            let redirectTo = user.roles.includes('ROLE_CONTRACTOR') ? 'ContractorRegister' : 'ProfessionalRegister'

            self.$router.push({
                name: redirectTo
            })
        }
    },

    updateImpersonatedUser() {
        if (this.$cookie.get('impersonateEmail') && this.$cookie.get('adminToken')) {
            this.$store.commit('setImpersonationData', {
                token: this.$cookie.get('adminToken'),
                email: this.$cookie.get('impersonateEmail')
            })

            this.$store.dispatch('storeUserInfo')
        }
    },
    cancelImpersonation() {
        this.$store.commit('resetImpersonationData')
        this.$cookie.delete('impersonateEmail', {domain: process.env.VUE_APP_COOKIE_DOMAIN});
        this.$cookie.delete('adminToken', {domain: process.env.VUE_APP_COOKIE_DOMAIN});
        window.close()
    }
}
